import { TProduct, TTimeSlot } from 'feature/appeals/type'
import { convertDataToInterval } from 'helpers/date/convertDataToInterval'
import { Button } from 'ui'
import { InformationBlock } from 'widget/InformationBlock/InformationBlock'

import { TModalsType } from '../OrderInformationBlock'

import style from './OrderTime.module.scss'

type TOrderTime = {
  isEdit: boolean
  openModal: (type: TModalsType, product?: TProduct) => void
  timeSlotText: string
  timeSlots: TTimeSlot[]
}
export const OrderTime = ({
  isEdit,
  openModal,
  timeSlotText,
  timeSlots,
}: TOrderTime) => {
  return (
    <InformationBlock title={timeSlotText}>
      <div className={style.selectedDates}>
        <div className={style.timeSlots}>
          {timeSlots.map(timeSlot => (
            <div key={timeSlot.key} className={style.timeSlot}>
              {convertDataToInterval(timeSlot)}
            </div>
          ))}
        </div>

        {isEdit && (
          <Button
            variant='text'
            onClick={() => openModal('time')}
            className={style.changeDatesButton}
            data-testid='order-reschedule-btn'
          >
            Перенести
          </Button>
        )}
      </div>
    </InformationBlock>
  )
}
